export default __webpack_public_path__ + "static/1-511000e52c61c6f2e9cb617d0452c45c.svg";